import { ticketConfig } from "../config";

export default async function getDataGettersGlobal() {
  return {
    ticketConfig
  };
}
